import {styled} from '@mui/material/styles';

import {
    Card,
    TextM,
    WhiteSpace,
    Button,
    TextS
} from '../../components'
import Container from '@mui/material/Container';
import Drawer from '@mui/material/Drawer';

import useLanguage from '../../hook/useLanguage'

import CN from './CN'
import EN from './EN'
import TH from './TH'

import { useState, useRef, useEffect } from 'react';
import { Stack } from '@mui/material';

import {
    useProtocal,
    useSign
} from '../../hook/silver/useProtocal'

// import { withRouter } from 'react-router-dom';

// userProtocal
const config = {
    "繁": {
        button: "簽署上鏈",
        sub: "簽署上鏈操作會將協議 hash 簽名後永久保存到鏈上",
        back: "暫時跳過",
        content: CN,
        hash: '0xae1527fce9a3ead779c06c7974883d4a48ebb593b2c530a5b4c61b358dfce13d'
    },
    "EN": {
        button: "Sign On-Chain",
        sub: "The on-chain signing operation will permanently store the hashed and signed agreement on the blockchain.",
        content: EN,
        back: "Skip",
        hash: '0x6583816ad27df14cd2fcd5cfe971253eaa0368cc7f20230625bddd7620ddb4b7'
    },
    "TH": {
        button: "ลงนามบนบล็อกเชน",
        sub: "การลงนามบนบล็อกเชนจะบันทึกข้อตกลงที่ถูกแฮชและลงนามไว้บนบล็อกเชนอย่างถาวร",
        content: TH,
        back: "ข้ามชั่วคราว",
        hash: '0x1bed9a57aaff00aac82069c3b39b752104890af98b885b182457d6ba869ee774'
    }
}

function Index({cloes}) {
    const {
        lang,
        resources,
        checkoutLanguage
    } = useLanguage()
    const {
        // button,
        sub,
        content: Content,
        back,
        hash
    } = config[lang]
    const ref = useRef(null)
    const button = useSign(hash)


    // useEffect(() => {
    //     console.log(
    //         [ref.current.textContent]
    //     )
    //     async function init() {
    //         const encoder = new TextEncoder();
    //         const data = encoder.encode(ref.current.textContent);
    //         const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    //         const hashArray = Array.from(new Uint8Array(hashBuffer));
    //         const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    //         console.log(
    //             hashHex
    //         )
    //     }
    //      init()
    // },[])


    return (
        <>
            <Container sx={{paddingBottom:'80px', background:'#24262f'}}>
                <WhiteSpace />
                <div style={{textAlign:'center'}}>
                    {
                        resources.map(v =>
                            <TextM
                                key={v}
                                style={{padding: '8px 16px'}}
                                color={lang === v ? 1 : 2}
                                onClick={() => {
                                    checkoutLanguage(v)
                                }}
                            >{v}</TextM>
                        )
                    }
                </div>
                <WhiteSpace />
                <Card ref={ref}>
                    <Content/>
                </Card>
                <WhiteSpace />
            </Container>
            <FootWrap>
                <FootFixed>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Button style={{width: '64%'}} {...button}/>
                        <Button type='e' style={{width: '34%'}} onClick={cloes}>{back}</Button>
                    </Stack>
                    <TextS style={{display:'block',padding:'4 auto 16px'}}>{sub}</TextS>
                </FootFixed>
            </FootWrap>
        </> 
    )
}

export default Index
// export default withRouter(PageNav)

const FootWrap = styled('div')`
    width: 100%;
    height: 76px;
    position: relative;
`

const FootFixed = styled('div')`
    width: 100%;
    bottom: 0px;
    position: fixed;
    text-align: center;
    background: #3a3c45;
    padding: 10px 8px 14px;
    box-shadow: 0px -2px 5px #24262f;
`


export function CheckProtocal({children}) {
    const signed = useProtocal()
    const [open, setOpen] = useState(false);
    const cloes = () => {
        setOpen(false)
    }
    return (
        <div style={{position:'relative'}}>
            {
                signed &&
                <>
                    <ToProtocal onClick={() => {
                        setOpen(true)
                    }}/>
                    <Drawer
                        open={open}
                        anchor='bottom'
                    >
                        <Index cloes={cloes}/>
                    </Drawer> 
                </>
            }
            {children}
            
        </div>
    )
}

const ToProtocal = styled('div')`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
`